import React from 'react';
import useReveal from '../../hooks/useReveal';

// TODO: verify final spec values with production build.
const SPECS = [
  { label: 'Drive Mode', value: 'Pneumatic Lift & Drop' },
  { label: 'Air Requirement', value: '100+ PSI Shop Compressor' },
  { label: 'Frame Material', value: 'Fully Galvanized Steel' },
  { label: 'Controller', value: 'Off-Hammer Proprietary "Black Box"' },
  { label: 'Piling Compatibility', value: '8" and 10" Standard Piles' },
  { label: 'Electronics Warranty', value: '1 Year' },
  { label: 'Origin', value: 'Fort Myers, FL · U.S.A.' },
  { label: 'Shipping', value: 'Nationwide (Lower 48)' },
];

export default function HammerSpecs() {
  const [ref, revealed] = useReveal(0.15);

  return (
    <section
      ref={ref}
      id="hammer-specs"
      data-testid="hammer-specs-section"
      className="relative bg-[#050608] border-t border-white/5 py-16 sm:py-20 lg:py-28 overflow-hidden"
    >
      <div className="relative max-w-6xl mx-auto px-5 sm:px-6 lg:px-10">
        <div
          className={`max-w-3xl transition-all duration-700 ease-out ${
            revealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <div className="flex items-center gap-3 mb-3 sm:mb-4">
            <span className="h-px w-8 sm:w-10 bg-cyan-400" />
            <span className="font-tech text-cyan-300 text-[10px] sm:text-[11px] uppercase tracking-[0.28em]">
              Specifications
            </span>
          </div>
          <h2 className="font-display text-white text-3xl sm:text-4xl md:text-5xl font-bold uppercase leading-[1.02] tracking-tight">
            The details, <span className="text-cyan-300">on the record.</span>
          </h2>
        </div>

        <div
          className={`mt-10 sm:mt-14 panel rounded-xl overflow-hidden transition-all duration-700 ease-out ${
            revealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
          style={{ transitionDelay: revealed ? '200ms' : '0ms' }}
        >
          <dl className="divide-y divide-white/5">
            {SPECS.map((s, idx) => (
              <div
                key={s.label}
                className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-6 px-5 sm:px-8 py-4 sm:py-5 items-baseline"
                data-testid={`hammer-spec-${idx}`}
              >
                <dt className="font-tech text-cyan-300/80 text-[11px] uppercase tracking-[0.24em]">
                  {s.label}
                </dt>
                <dd className="sm:col-span-2 text-zinc-200 text-sm sm:text-base font-medium">
                  {s.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div
          className={`mt-10 sm:mt-12 panel rounded-xl p-6 sm:p-8 md:p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-5 transition-all duration-700 ease-out ${
            revealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
          style={{ transitionDelay: revealed ? '400ms' : '0ms' }}
        >
          <div>
            <div className="font-tech text-cyan-300 text-[10px] sm:text-[11px] uppercase tracking-[0.28em] mb-1">
              Sticker Price
            </div>
            <div className="font-display text-white text-4xl sm:text-5xl font-bold tracking-tight">
              $10,500<span className="text-cyan-300">*</span>
            </div>
            <div className="mt-2 text-zinc-500 text-sm">
              <span className="text-cyan-300">*</span> Does not include shipping (quoted separately)
            </div>
          </div>
          <a
            href="#hammer-quote"
            data-testid="hammer-specs-buy-btn"
            className="btn-teal px-6 py-3 rounded-md text-xs sm:text-sm uppercase tracking-[0.16em] sm:tracking-[0.18em] whitespace-nowrap"
          >
            Buy Now
          </a>
        </div>
      </div>
    </section>
  );
}
